import Swal, { SweetAlertIcon } from "sweetalert2";
import Resources from "../types/Resources";

let timeOut: any;

export function showSuccessAlert(message: string | undefined) {
    if (!message) return;

    const alert = document.getElementById("success-alert");
    const messageContainer = document.getElementById("success-alert__message");

    if (!alert) {
        console.error("Could not find success alert element.");
        return;
    }

    if (!messageContainer) {
        console.error("Could not find success alert message element.");
        return;
    }

    messageContainer.innerText = message;

    alert.classList.remove("d-none");
    alert.classList.add("d-flex");

    if (timeOut) clearTimeout(timeOut);

    timeOut = setTimeout(() => {
        alert.classList.remove("d-flex");
        alert.classList.add("d-none");
        messageContainer.innerText = "";
    }, 4000);
}

export function showDangerAlert(message: string) {
    if (!message) return;

    const alert = document.getElementById("danger-alert");
    const messageContainer = document.getElementById("danger-alert__message");

    if (!alert) {
        console.error("Could not find danger alert element.");
        return;
    }

    if (!messageContainer) {
        console.error("Could not find danger alert message element.");
        return;
    }

    messageContainer.innerText = message;

    alert.classList.remove("d-none");
    alert.classList.add("d-flex");

    if (timeOut) clearTimeout(timeOut);

    timeOut = setTimeout(() => {
        alert.classList.remove("d-flex");
        alert.classList.add("d-none");

        messageContainer.innerText = "";
    }, 4000);
}

export function showDialog(header: string, body: string, type: string) {
    Swal.fire({
        title: header,
        html: body,
        icon: type as SweetAlertIcon,
        confirmButtonText: "OK"
    });
}

export function showDangerDialog(header: string | undefined, message: string | undefined) {
    Swal.fire({
        title: header ?? "",
        text: message ?? "",
        icon: "error"
    });
}

type DialogConfig = {
    type: "error" | "success" | "info" | "warning";
    title: string;
    html: string;
    onConfirmAsync: () => Promise<void>;
    confirmButtonText: string;
    cancelButtonText: string;
};
export async function showDialogAsync(config: DialogConfig) {
    const result = await Swal.fire({
        icon: config.type,
        title: config.title,
        html: config.html,
        confirmButtonText: config.confirmButtonText,
        cancelButtonText: config.cancelButtonText,
        showCloseButton: true,
        showCancelButton: true
    });

    if (!result.isConfirmed) {
        return;
    }

    await config.onConfirmAsync();
}

export function getRequestVerificationToken() {
    const tokenInput = document.querySelector("[name=__RequestVerificationToken]") as HTMLInputElement;

    if (!tokenInput) {
        console.error("Ingen RequestVerificationToken hittades.");
        return "";
    }

    return tokenInput.value;
}

export function debounce(func: (...a: any[]) => any, timeout: number) {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(args), timeout);
    };
}

export function getTextPreview(text: string, maxLength = 128): string {
    const ellipsis = "...";

    if (text.length <= maxLength) {
        return text.substring(0, maxLength) + ellipsis;
    }

    return text;
}

export function createResources(resourceObj: { [key: string]: string }): Resources {
    const resources = new Map(Object.entries(resourceObj));

    return resources;
}

export function showValidationErrorDialog(validationErrors: string[], resources: Resources) {
    if (!validationErrors) return;

    const validationErrorLocations = validationErrors
        .filter((e) => e.length > 0)
        .map((e) => (e.endsWith(":") ? e.substring(0, e.length - 1) : e));

    Swal.fire({
        icon: "error",
        width: "600px",
        html: `
        <div class="d-flex flex-column">
            <div class="fw-bold">${resources.get("InformationCouldNotBeSaved")}</div>
            ${
                validationErrorLocations.length > 0
                    ? `
                <div class="text-start ps-4">
                        <label class="mt-3 text-start">${resources.get("ErrorLocations")}:</label>
                        <ul>
                            ${validationErrorLocations.map((e) => `<li class="text-start">${e}</li>`).join("")}
                        <ul>
                </div>
            `
                    : ""
            }
        </div>
        `
    });
}

export function showPortControlRecaptchaErrorDialog(resources: Resources) {
    Swal.fire({
        icon: "error",
        width: "600px",
        html: `
        <div class="d-flex flex-column">
            <div class="fw-bold">${resources.get("RecaptchaValidationErrorHeader")}</div>
                <div class="text-start ps-4">
                    ${resources.get("RecaptchaValidationErrorMessage0")}
                    <span style='white-space: nowrap;'>010-332 75 15</span>
                    ${resources.get("RecaptchaValidationErrorMessage1")}
                    <a href='mailto:portcontrol@portgot.se'>portcontrol@portgot.se</a>.
                </div>
            `
    });
}

export function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
